import { useInboxLabelsQuery } from "@qw/graphql";
import { FieldCombobox, type FieldComboboxOption, FieldInput, Group, useOpenForm } from "@qw/ui";
import { useMemo } from "react";
import { z } from "zod";
import { useCreateLabel } from "@/providers/use-create-label";

export const CreateLabelFormFields = () => {
  const { data: labelsData } = useInboxLabelsQuery();

  const itemOptions: FieldComboboxOption[] = useMemo(() => {
    return labelsData?.inboxLabels?.map((label) => ({ label: label.name, value: label.name })) || [];
  }, [labelsData?.inboxLabels]);

  return (
    <Group>
      <FieldInput label="Label Name" name="name" placeholder="Enter label name" />
      <FieldCombobox label="Nest under" name="parentLabel" placeholder="Select a parent label" options={itemOptions} />
    </Group>
  );
};

export const useCreateLabelForm = () => {
  const { openForm } = useOpenForm();
  const [createLabel] = useCreateLabel();

  return () => {
    openForm(<CreateLabelFormFields />, {
      mode: "onChange",
      title: "Create label",
      validationSchema: z.object({
        name: z.string().min(1, "Label name is required"),
        parentLabel: z.string().optional(),
      }),
      defaultValues: {
        name: "",
        parentLabel: "",
      },
      onSubmit: (values) =>
        createLabel({ name: values.parentLabel ? `${values.parentLabel}/${values.name}` : values.name }),
    });
  };
};
